//import headshot from './headshot.jpeg'
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="topstuff">
        <h2>
          L Phansalkar (they/them)
        </h2>
        <h3>
          Technical Support Engineer and Professional Speaker
        </h3>
        </div>
      </header>
<div className="content">
  <h2 className="link">Links</h2>
  <p></p>
  <a href="/LPR.pdf" download="PhansalkarResume24">download my <b>resume</b></a>
  <p></p>
  
  <p></p>
  <a href= "https://www.linkedin.com/events/outintechpride-alltogethernow7202049812949549056/theater/" >watch my<i> Out In Tech</i> <b> Pride Keynote Speech </b> (June 2024)</a>
  <p></p>
  
  <p></p>
  <a href=  "http://apadivision16.org/wp-content/uploads/2021/03/TSP-Spring-2021.pdf#page=21" > read my <i>The School Psychologist</i> <b> Journal Publication </b> (Spring 2021)</a>
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <a href="https://web.archive.org/web/20150630183736/http://www.outerplaces.com/tag?tag=Technology" > read my <i>Outer Places</i> <b> Online Science & Technology News Publications </b>(2015)</a>
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <p></p>

  <p></p>

</div>
      </div>
  );
}

export default App;
